import { useMemo } from 'react';
import useTransferListStore from '../store/transfer-list-store';

export function useIsClear() {
  const { config, included, excluded } = useTransferListStore();

  return useMemo(() => {
    const excludedDraft =
      config?.items?.filter((x) => !x.disable).map((x) => x.id) ?? [];
    const includedDraft =
      config?.items?.filter((x) => x.disable).map((x) => x.id) ?? [];

    return (
      includedDraft.length === included?.length &&
      excludedDraft.length === excluded?.length &&
      includedDraft.every((id) => included?.includes(id)) &&
      excludedDraft.every((id) => excluded?.includes(id))
    );
  }, [config, included, excluded]);
}
